import React from "react";
import { useQuery, useQueryClient } from "react-query";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import categoryServices from "../../services/categories";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import CategoryForm from "../../components/Forms/CategoryForm";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { imageFormat, imageSize } from "../../utils/functions";
import { useDispatch } from "react-redux";
import { getCategories } from "../../redux/slicers/config";

const validationSchema = Yup.object().shape({
    name_ar: Yup.string().required("هذا الحقل مطلوب"),
    name_en: Yup.string().required("هذا الحقل مطلوب"),
    img: Yup.mixed()
        .test("image-format", "يرجى تحميل صورة", value => {
            if (value) {
                if (value?.type) {
                    return imageFormat.includes(value.type.split("/")[1]);
                }
                return true;
            }

            return false;
        })
        .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
            if (value) {
                if (value?.type) {
                    return imageSize >= value.size;
                }
                return true;
            } else {
                return false;
            }
        }),
});
const EditCategory = ({ title }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { data, isLoading, error } = useQuery(["getCategory", id], () => {
        return categoryServices.getCategory(id);
    });
    const onSubmit = (values, { setSubmitting }) => {
        const formData = new FormData();
        const formattedData = {
            name_ar: values.name_ar,
            name_en: values.name_en,
        };
        categoryServices
            .editCategory(formattedData, id)
            .then(res => {
                if (values.img !== data.data.data.img) {
                    formData.append("img", values.img);
                    categoryServices
                        .editCategoryImg(formData, id)
                        .then(res => {
                            queryClient.refetchQueries("getCategories");
                            toast.success("تم التعديل بنجاح");
                            dispatch(getCategories());

                            setTimeout(() => {
                                navigate("/categories");
                            }, 1500);
                        })
                        .catch(err => {
                            console.log(err);
                            setSubmitting(false);
                        });
                } else {
                    queryClient.refetchQueries("getCategories");
                    toast.success("تم التعديل بنجاح");
                    dispatch(getCategories());

                    setTimeout(() => {
                        navigate("/categories");
                    }, 1500);
                }
            })
            .catch(err => {
                console.log(err);
                if (err?.response?.status === 404) {
                    toast.error("غير موجود السجل");
                } else {
                    toast.error("حصل خطأ اثناء التحديث");
                    console.log(err);
                }
                setTimeout(() => {
                    setSubmitting(false);
                }, 1500);
            });
    };
    if (error || isNaN(Number(id)) || !id) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard className={isLoading ? "min-h-[400px]" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <CategoryForm
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        initialValues={{ ...data.data.data }}
                        btnText="تعديل القسم"
                    />
                )}
            </DCard>
        </div>
    );
};

export default EditCategory;
